export const apiUrl = process.env.VUE_APP_DOMAIN;
export const authApiUrl = process.env.VUE_APP_AUTH_API_DOMAIN;
export const appName = process.env.VUE_APP_NAME;
export const authApiSecretAccessKey = process.env.VUE_APP_AUTH_API_SECRET_ACCESS_KEY;
